export default "__VITE_ASSET__af6b4945__"